import React, { useEffect, useRef } from "react";
import notificationSound from "../../src/assets/new.notification.mp3.mp3";

const Notification = ({ message, onClose, stopAudioRef }) => {
  const audioRef = useRef(null);

  useEffect(() => {
    // Create audio instance and store in ref
    audioRef.current = new Audio(notificationSound);
    audioRef.current.play().catch((error) => {
      if (error?.name !== "NotAllowedError") {
        console.warn("Notification sound unavailable:", error.message);
      }
    });

    // Expose stop function to parent through ref
    if (stopAudioRef) {
      stopAudioRef.current = () => {
        if (audioRef.current) {
          audioRef.current.pause();
          audioRef.current.currentTime = 0;
        }
      };
    }

    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
      }
    };
  }, []);

  return (
    <div className="fixed top-40 right-4 bg-green-500 text-white px-4 py-3 rounded-lg shadow-lg transition-opacity duration-300 animate-fade-in-out">
      <p>{message}</p>
    </div>
  );
};

export default Notification;
